module.exports = __webpack_public_path__ + "static/media/18ECA38.0db7b354.jpg";